import { useMemo } from 'react';
import { HubBasePage } from '../../../../../types';
import {
  DiscoveryContentTypes,
  InformaMetaTagPageType,
} from '../../../../../constants';
import { useRootSelector } from '../../../../../store/hooks';
import { selectBrandHubPage } from '../../store/features/page';
import { selectBrandHubOptions } from '../../store/features/options';
import {
  HubPageNames,
  selectHubDiscovery,
  SortTypes,
} from '../../../../../store/features/discovery';
import PageLayout from '../../layouts/PageLayout';
import { MetaTags } from '../../../shared/MetaTags';
import { AggregatedProductSearchPage } from '../../../shared/siteBuilder/AggregatedProductSearchPage';

export function Search() {
  const {
    data: {
      page: {
        details: { title, description, metaDescription, searchQueryData },
      },
      header: {
        headerNavBar: { brandLogo },
      },
    },
  } = useRootSelector(selectBrandHubPage<HubBasePage>());
  const {
    data: { name: hubName, subBrandName: brandName },
  } = useRootSelector(selectBrandHubOptions);
  const {
    data: { facets, records },
  } = useRootSelector(selectHubDiscovery);

  const heading = title || 'Search';

  const defaultValues = useMemo(
    () => ({
      type: [DiscoveryContentTypes.ALL],
      requestedSortType: SortTypes.FEATURED,
      deliveryType: [],
      subBrands: [brandName],
      sectors: [],
      topics: [],
      month: [],
      location: [],
      language: [],
      awardGroup: [],
      informationType: [],
      partners: [],
      creditPartners: [],
      accessTypes: [],
      createdTimeFrame: [],
      availableSubBrands: [brandName],
      page: 1,
      count: 20,
      searchInput: '',
    }),
    [brandName],
  );

  return (
    <PageLayout>
      <MetaTags
        title={heading}
        titleSuffix={hubName}
        description={metaDescription}
        thumbnail={brandLogo?.path}
        informaPageId={HubPageNames.search}
        informaPageType={InformaMetaTagPageType.BasePage}
      />
      <AggregatedProductSearchPage
        pageName={HubPageNames.search}
        title={heading}
        subtitle={description}
        records={records}
        facets={facets}
        defaultValues={defaultValues}
        searchQueryData={searchQueryData}
      />
    </PageLayout>
  );
}
